import React from 'react';
import Link from '../atoms/link';

const Footer = ({
	pageDisclaimer = false
}) => {
	const pageDisclaimerContent = (pageDisclaimer) ? (
		<p>{pageDisclaimer}</p>
	) : null;

	return (
		<div className='co-footer'>
			<div className='co-footer__main'>
				<div className='l-container'>
					<div className='l-grid__row l-grid__middle-xs co-footer__logo-links'>
						<div className='l-grid__col-md co-footer__links--secondary'>
							<Link url='https://www.unlock.com/legal' classNames='co-footer__link' target='_blank' external>
								Privacy Policy
							</Link>
							<Link url='https://www.unlock.com/legal' classNames='co-footer__link' target='_blank' external>
								Terms of Use
							</Link>
							<Link url='https://www.unlock.com/about-us#Contact-Us' classNames='co-footer__link' target='_blank' external>
								Contact Us
							</Link>
						</div>
					</div>
					<div className='l-grid__row'>
						<div className='l-grid__col-xs-12 l-spacing__m-t--24 co-footer__disclaimer'>
							{/* {pageDisclaimerContent} */}
							<p>THIS IS AN ADVERTISEMENT AND NOT AN ACTUAL NEWS ARTICLE, BLOG, OR CONSUMER PROTECTION UPDATE. THE STORY DEPICTED ON THIS SITE AND THE PERSON DEPICTED IN THE STORY ARE NOT ACTUAL NEWS. RATHER, THIS STORY IS BASED ON THE RESULTS THAT SOME PEOPLE WHO HAVE USED UNLOCK.COM HAVE ACHIEVED. THE RESULTS PORTRAYED IN THE STORY AND IN THE COMMENTS ARE ILLUSTRATIVE, AND MAY NOT BE THE RESULTS THAT YOU ACHIEVE WITH UNLOCK.COM.</p>
							<br/>
							<p>Unlock Agreements are provided exclusively by Unlock Partnership Solutions Inc., Unlock Partnership Solutions AO1 Inc., Unlock Partnership Solutions AO2 Inc., and Unlock Homeownership Solutions Inc., all of which are wholly-owned subsidiaries of Unlock Technologies, Inc. (collectively, “Unlock”). Unlock holds the following Real Estate Broker licenses: Arizona - CO698434000; California - 02141737; Colorado - IC100092644; D.C. - REO40000074; Florida - CQ1062618; Hawaii - RB-23715; Illinois - 478027520; Massachusetts - 423954; Michigan – 6505431174; Minnesota – 40797638; Nevada - B.1002613; New Jersey – 2185646; North Carolina - C33769; Oregon – 201243836; Pennsylvania - RB069442; South Carolina – 25463; Tennessee – 265329; Utah - 12139955-CN00; Virginia – 0226033193; and Washington – 21010143. The applicable Unlock entity enters into the Unlock Agreements directly with consumers and does not act as an agent or broker on behalf of any third-party. No agency relationship shall be formed between any Unlock entity and a consumer pursuant to or in connection with an Unlock Agreement.</p>
							<br/>
							<p>All Rights Reserved.</p>
							<br/>
							<p>*Application to funding may take over 60 days to complete. Funding timelines may vary depending on factors, including, but not limited to appraisal turnaround times and follow-ups required for verification of property details and a clear title. Liens or any interest secured on the property by MV Realty must be paid off and removed as a condition to close. Terms and conditions apply.</p>
							<br/>
							<p>The following limitations shall apply: property must be your primary residence; no bankruptcy, foreclosure action, short sale, or deed in lieu within the previous five years; no 90-day delinquencies on any mortgage within the prior 24 months; no 120-day delinquencies on any mortgage within the prior 36 months; Unlock must be in no greater than 2nd lien position and home must be clear of any liens deemed unacceptable by Unlock (Unlock may require investment proceeds to be used in order to clear any unacceptable pre-existing liens as a condition to close); Unlock may also require investment proceeds to be used to pay off certain outstanding debts as a condition to close, including (but not limited to) paying off an amount that is sufficient to result in a debt-to-income ratio (“DTI”) of no more than 45%; minimum investment amount of $30,000; property condition rating, as described in the Uniform Appraisal Dataset (UAD), must be at least C4 or better.</p>
							<br/>
							<p>Each home equity agreement (HEA) is subject to additional individual underwriting review.</p>
							<br/>
							<p>*Source: https://www.cnbc.com/select/us-credit-card-debt-hits-all-time-high/</p>
						</div>
					</div>
				</div>
			</div>
			<div className='co-footer__copyright'>
				<div className='l-container'>
					<div className='l-grid__row'>
						<div className='l-grid__col-xs'>
							<p>&copy; Copyright {new Date().getFullYear()} Home Equity Tips. All rights reserved.</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Footer;
